var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconReportDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6673 0H3.33398C1.95907 0 0.833984 1.12508 0.833984 2.50005V12.5002C0.833984 13.8751 1.95907 14.9999 3.33398 14.9999H6.66732V20L11.6677 15.0002H16.6673C18.0425 15.0002 19.1673 13.8754 19.1673 12.5002V2.50005C19.1673 1.12508 18.0425 0 16.6673 0ZM8.75065 2.5H10.834V10H8.75065V2.5ZM10.834 11.25H8.75065V13.3333H9.58398H10.834V11.25Z",
    fill: "#EFF3F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReportDisabled);
export default __webpack_public_path__ + "static/media/icon_report-disabled.af719daacbb51eacd48fc991347b9c00.svg";
export { ForwardRef as ReactComponent };